import React from "react";
import { Link } from "react-router-dom";

export const About = (props) => {
  const data = props.data || {};
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="about-media">
              <img src="img/quarry-aerial.jpg" className="img-responsive" alt="International Rocks quarry and block yard in the Omani interior" />
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <span className="eyebrow dark">About Us</span>
              <h2>{data.title || "About Us"}</h2>
              <p>{data.paragraph}</p>
              <p>{data.paragraph2}</p>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {data.Why ? data.Why.map((d, i) => <li key={`${d}-${i}`}>{d}</li>) : null}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {data.Why2 ? data.Why2.map((d, i) => <li key={`${d}-${i}`}>{d}</li>) : null}
                  </ul>
                </div>
              </div>
              <Link to="/about" className="btn btn-custom">
                More About International Rocks
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
